/**
 * API Configuration
 * Uses REACT_APP_ENVIRONMENT to determine the appropriate API URL.
 *
 * Environments:
 *   - Production (REACT_APP_ENVIRONMENT=production): congreso-transparente-back-end.onrender.com (legacy)
 *   - Staging (REACT_APP_ENVIRONMENT=staging): congreso-transparente-api-staging.onrender.com
 *   - Development (no REACT_APP_ENVIRONMENT): localhost:8000
 *
 * Note: NODE_ENV is always 'production' during CRA builds, so we use REACT_APP_ENVIRONMENT instead.
 * Environment variables are baked in at build time - redeploys require fresh builds to pick up changes.
 */

// API URLs for each environment
const API_URLS = {
  production: 'https://congreso-transparente-api.onrender.com',
  staging: 'https://congreso-transparente-api-staging.onrender.com',
  development: 'http://localhost:8000',
  // Legacy URL (keeping for backwards compatibility during migration)
  legacy: 'https://congreso-transparente-back-end.onrender.com',
};

const getApiUrl = (): string => {
  // 1. First check for explicit environment variable (highest priority)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // 2. Use REACT_APP_ENVIRONMENT to determine API URL
  // Note: NODE_ENV is always 'production' during CRA builds, so we can't rely on it
  const environment = process.env.REACT_APP_ENVIRONMENT;

  if (environment === 'production') {
    // Production: use legacy URL until migration is complete
    return API_URLS.legacy;
  }

  if (environment === 'staging') {
    // Staging/Preview: use staging backend
    return API_URLS.staging;
  }

  // 3. Default to localhost for local development
  return API_URLS.development;
};

export const API_BASE_URL = getApiUrl();
export const API_ENDPOINT = `${API_BASE_URL}/api`;

// Helper function for building API URLs
export const buildApiUrl = (path: string): string => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${API_ENDPOINT}/${cleanPath}`;
};
